module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-600-vietnamese10.0925fd7.woff2";